import { useState } from 'react';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import axios from 'axios';


function FavoriteButton({ itemType, itemId, hasFavoritedInitial, favoriteCountInitial, userId }) {
    const { token } = useAuth();
    const { backendApiBaseUrl } = useConfig();
    const [hasFavorited, setHasFavorited] = useState(hasFavoritedInitial);
    const [favoriteCount, setFavoriteCount] = useState(favoriteCountInitial);

    const parseItemId = (itemKey) => {   
        if (typeof itemKey === 'string' && itemKey.includes('-')) {
            const [type, id] = itemKey.split('-');
            return { type, id: parseInt(id, 10) };
        } else {
            return { type: undefined, id: parseInt(itemKey, 10) };
        }
    };

    const toggleFavorite = async () => {
        if (!userId) return;
        const { id } = parseItemId(itemId);
        try {
            if (hasFavorited) {
                await axios.delete(`${backendApiBaseUrl}/favorites`, {
                    data: { itemType, userId, id },
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                    },
                });
                setFavoriteCount(favoriteCount - 1);
            } else {
                await axios.post(`${backendApiBaseUrl}/favorites`,
                    { itemType, userId, id },
                    {
                        headers: {
                            Authorization: `Bearer ${token.token}`,
                        },
                    }
                );
                setFavoriteCount(favoriteCount + 1);
            }
            setHasFavorited(!hasFavorited);
        } catch (err) {
            console.error("Failed to toggle favorite", err);
        }
    };

    return (
        <div onClick={toggleFavorite} style={{ cursor: 'pointer' }}>
            <i className={hasFavorited ? "fa-solid fa-heart" : "fa-regular fa-heart"}></i>
            <span style={{ marginLeft: '5px' }}>{favoriteCount}</span>
        </div>
    );
}

export default FavoriteButton;